//  PC_PG_01 ,  PC_PG_02 - importing required statements
import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { deletePolicy, getPolicy, policyHighlight, updatePolicy } from '../../service/PerformanceAPI';
import moment from 'moment';
import { Sign } from "../../components/AddSignature/sign"

// import './Policy.css';
import EvaluationPopUp from '../../components/EvaluationPopUp';
import $ from 'jquery';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Loader from '../../StaticComponent/Loader';
import Popup from '../../components/ConformationPopup/Popup';
import { encryptStorage } from '../../constant';
import { getS3 } from '../../utils/Download';
import { getActivePolices, getInactivePolices } from '../../service/todo';
import { getAllpolices, getPolicyDropDown } from '../../service/todo';
import { Tooltip } from 'antd';

// PC_PG_04 - ManagePolicy component declaration
export default function ManagePolicy() {

    const navigateTo = useNavigate();
    const location = useLocation();
    const [state, setState] = useState(location?.state);
    const [policySearch, setPolicySearch] = useState("");
    const [view, setView] = useState(false);
    const [sign, SetSign] = useState(false);
    

    // PC_PG_05 - filterObj object declaration
    let filterObj = {
        search: '',
        limit: 10,
        page: 1,
        category: '',
        startFromDate: '',
        startToDate: '',
        expiryFromDate: '',
        expiryToDate: '',
        controlOwnerId: '',
        approverId: '',
        sort: 'p.created_at',
        order: 'DESC',
        approvedViewId: encryptStorage.getItem("grc") ? ""
            : encryptStorage.getItem("secAudits")
                ? "Sec Audits"
                : encryptStorage.getItem("employeeId")
    };

    // PC_PD_69 to  PC_PD_71 - for navigation and bread crumbs
    let breadCrumbsData =
        [
            { title: 'Dashboard', isActive: true, path: '/Overview' },
            { title: 'How Do I?', isActive: true, path: '' },
            { title: 'Policy', isActive: false, path: '/policy' }
        ]

    // PC_PG_06, PC_PG_07 - state variable declaration
    const [filterData, setFilterData] = useState(filterObj);
    const [policyAdvancedFilter, setPolicyAdvancedFilter] = useState('');
    const [hideContainer, setHideContainer] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    //sort
    //  PC_PG_33 for ascending and descending sort
    const [columnOrder, setColumnOrder] = useState('ASC');
    const [columnName, setColumnName] = useState('emp_name');
    const [sorthide, setsorthide] = useState('emp_name@ASC');

    const [activePolices, setActivePolices] = useState([]);
    const [getAllpolicy, setAllpolicy] = useState([]);
    const [inactivePolicies, setInactivePolicies] = useState([]);
    const [addSign, setAddSign] = useState("");
    const [policyId, setPolicyId] = useState(0);
    const [policyName, setPolicyName] = useState("");

    const [pagination, setPagination] = useState([])
    const [policyTab, setPolicyTab] = useState('all')
    //search for active and inactive policy
    const [search, setSearch] = useState('')
    const [showMore, setShowMore] = useState(true);
    const [clearFilter, setClearFilter] = useState(true);
    const [sortOrder, setSortOrder] = useState("asc");
    const [sortOrderr, setSortOrderr] = useState("asc");
    const [preSignedURL, setPresignedURL] = useState("");



    useEffect(() => {
        getActivePolicy();
        if (encryptStorage.getItem("grc")) inActivePolicy();
        if (!(encryptStorage.getItem("secAudits") || encryptStorage.getItem("grc") || encryptStorage.getItem("groupid") == 1)) { setPolicyTab('allasactive') }
    }, []);
    useEffect(() => {
        if (encryptStorage.getItem("secAudits") || encryptStorage.getItem("grc") || encryptStorage.getItem("groupid") == 1) { allpolicy() }
    }, [sorthide, showMore, filterData.limit, clearFilter]);

    // PC_PD_65 to  PC_PD_68 - clear option
    const filterclear = () => {
        // //debugger
        let clearfilterObj = {
            search: '',
            limit: 10,
            page: 1,
            category: '',
            startFromDate: '',
            startToDate: '',
            expiryFromDate: '',
            expiryToDate: '',
            controlOwnerId: '',
            approverId: '',
            sort: 'p.modified_at',
            order: 'DESC',
            approvedViewId: encryptStorage.getItem("grc") ? ""
                : encryptStorage.getItem("secAudits")
                    ? "Sec Audits"
                    : encryptStorage.getItem("employeeId")
        };
        setClearFilter(!clearFilter);
        setFilterData(clearfilterObj);
        setHideContainer(false);
    };
    async function filterOnchange(e) {
        try {
            setPolicyAdvancedFilter(e.target.value);
        } catch (e) {

            throw e;
        }
    }

    //  PC_PD_08 , PC_PD_09 - all policy function
    // PC_PD_23 - respionse
    async function allpolicy() {
        //debugger;
        try {
            setIsLoading(false);
            let response = await getAllpolices(filterData);
            if (response.statusCode == 200 && response.data) {
                setAllpolicy(response.data[0]);
                setPagination(response.data[1])
            }
            else {
                setAllpolicy([]);
                setPagination([])
            }
        } catch (error) {
            console.log(error.message);
            throw error;
        } finally {
            setIsLoading(true);
        }
    }

    // PC_PD_08, PC_PD_08 - active policy function declaration
    // PC_PD_23 -response
    async function getActivePolicy() {
        try {
            // //debugger;
            setIsLoading(false);
            let response = await getActivePolices({ employeeId: encryptStorage.getItem('employeeId'), search });
            if (response.statusCode == 200) {
                setActivePolices(response.data);
            }
        } catch (error) {
            console.log(error.message);
            throw error;
        } finally {
            setIsLoading(true);
        }
    }

    // PC_PD_05 to  PC_PD_14 to get in active policy
    // PC_PD_24 - set state response data
    async function inActivePolicy() {
        try {
            setIsLoading(false);
            let response = await getInactivePolices({ employeeId: encryptStorage.getItem('employeeId'), search });
            if (response.statusCode == 200) {
                setInactivePolicies(response.data);
            }
        } catch (error) {
            console.log(error.message);
            throw error;
        } finally {
            setIsLoading(true);
        }
    }

    // function toggleTab(value) {
    //     setToggle(value);
    // }



    // PC_PD_40 to  PC_PD_42;  PC_PD_45 to  PC_PD_47 - to sort in
    //ascending and descending
    const sortClicked = (e) => {
        //debugger
        try {
            //debugger;
            let sortID = e.target.id;
            let sortval = sortID.split('@');
            setFilterData({ ...filterData, sort: sortval[0], order: sortval[1] });
            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
        } catch (e) { }
    };

    const [sortIcon, setsortIcon] = useState('policy_name@ASC')

    const handleSort = (key) => {
        let sortID = key;
        let sortval = sortID.split('@');
        const sortedData = [...activePolices].sort((a, b) => {
            if (sortOrder === "asc") {
                if (a[key] < b[key]) return -1;
                if (a[key] > b[key]) return 1;
                return 0;
            } else {
                if (a[key] < b[key]) return 1;
                if (a[key] > b[key]) return -1;
                return 0;
            }

        });
        setColumnName(sortval[0]);
        setColumnOrder(sortval[1]);
        setActivePolices(sortedData);
        setInactivePolicies(sortedData)
        // Toggle sort order
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        // setsortIcon(sortIcon==='sortID@ASC'? 'sortID@DESC':'sortID@ASC')
    };

    const handleSortt = (key) => {
        let sortID = key;
        let sortval = sortID.split('@');
        const sortedDataa = [...inactivePolicies].sort((a, b) => {
            if (sortOrderr === "asc") {
                if (a[key] < b[key]) return -1;
                if (a[key] > b[key]) return 1;
                return 0;
            } else {
                if (a[key] < b[key]) return 1;
                if (a[key] > b[key]) return -1;
                return 0;
            }

        });
        setColumnName(sortval[0]);
        setColumnOrder(sortval[1]);
        setInactivePolicies(sortedDataa)
        // Toggle sort order
        setSortOrderr(sortOrderr === "asc" ? "desc" : "asc");
    };


    const filterCheck = () => {
        try {
            //debugger;
            setHideContainer(hideContainer == true ? false : true);
        } catch (error) {
            console.log(error.message, 'issue in onclick of filter');
        }
    };

    // PC_PD_34 to PC_PD_37 - to search for a value
    const handleSearch = (e) => {
        try {
            setFilterData({
                ...filterData,
                ['search']: e.target.value,
            });
        } catch (e) { }
    };


    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter' && policyTab == 'all') {
            allpolicy();
            setFilterData({
                ...filterData,
                "limit": 10
            });
            setShowMore(!showMore)
        }
        if (e.key === 'Enter' && (policyTab == 'active' || policyTab == 'allasactive')) {
            getActivePolicy();
        }
        if (e.key === 'Enter' && policyTab == 'inactive') {
            inActivePolicy();
        }

    };

    const searchClick = () => {
        if (policyTab == 'all') {
            allpolicy();
            setFilterData({
                ...filterData,
                "limit": 10
            });
            setShowMore(!showMore)
        }
        if (policyTab == 'active' || policyTab == 'allasactive') {
            getActivePolicy();
        }
        if (policyTab == 'inactive') {
            inActivePolicy();
        }
    };


    // PC_PD_60  to  PC_PD_64 - to bind the drop down filters
    async function getFilterDropDowns() {
        //debugger;
        let response = await getPolicyDropDown();
        const concatarray1 = response[0].data;
        const concatarray2 = response[1].data;
        const mergedArray = concatarray1.concat(concatarray2);
        setPolicyAdvancedFilter(mergedArray);
    }


    // PC_PD_60  to  PC_PD_64 - to bind the drop down filters
    // function bindFilterDropDowns() {
    //     //debugger;
    //     if (policyAdvancedFilter) {
    //         return policyAdvancedFilter.map((value, index) => {
    //             return <option value={value.emp_id}>{value.emp_name}</option>;
    //         });
    //     }
    // }

    // PC_PD_60  to  PC_PD_64 - to bind the drop down filters
    function bindFilterDropDowns() {
        //debugger;
        if (policyAdvancedFilter) {
            // Create a Set to store unique emp_ids
            const uniqueEmpIds = new Set(policyAdvancedFilter.map(value => value.emp_id));

            // Map unique emp_ids to options
            return Array.from(uniqueEmpIds).map(empId => {
                // Find the corresponding emp_name for each unique emp_id
                const empName = policyAdvancedFilter.find(value => value.emp_id === empId).emp_name;
                return <option key={empId} value={empId}>{empName}</option>;
            });
        }
    }

    // PC_PD_10 to  PC_PD_12 - to have a date format in mm/dd/yyy
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [month, day, year].join('-');
    }

    const getEmpNames = (approverLevel, empNames) => {
        const filteredNames = empNames.filter(name => name.approver_level === approverLevel);
        let result = '';
        for (let i = 0; i < filteredNames.length; i++) {
            result += `${filteredNames[i].emp_name} - ${filteredNames[i].approver_action ? filteredNames[i].approver_action : "Yet to approve"}`;
            if (i !== filteredNames.length - 1) {
                result += `, `;
            }
        }
        return result;
    };

    const getPolicyStatus = (approverLevel, empNames) => {
        const filteredNames = empNames.filter(name => name.approver_level === approverLevel);
        const hasRejected = filteredNames.some(name => name.approver_action === "rejected");
        const allApproved = filteredNames.every(name => name.approver_action === "approved");

        if (hasRejected) {
            return "reject";
        } else if (allApproved) {
            return "completed";
        } else {
            if (approverLevel == 1)
                return "pending";
            else {
                const filteredName = empNames.filter(name => name.approver_level === approverLevel - 1);
                const rejected = filteredName.some(name => name.approver_action === "rejected");
                const approved = filteredName.every(name => name.approver_action === "approved");
                if (rejected) {
                    return ""
                }
                else if (approved) {
                    return "pending"
                }
                else {
                    return
                }
            }
        }

    };

    function isApprovedOrRejected(empId, dataArray) {
        // Check if any object in the array has the provided emp_id and has an approver_action of "approved" or "rejected"
        return dataArray.some(item => item.emp_id === empId && ['approved', 'rejected'].includes(item.approver_action));
    }

    // PC_PD_24 to  PC_PD_26 - to bind the response and to check if its not empty
    function bindAllPolices() {
        if (getAllpolicy?.length == 0) {
            return (
                <tr>
                    <td colSpan={10}>
                        <div className="row justify-content-center">
                            <img
                                src="/Images/vadivelu.png"
                                alt="nodatafound"
                                className="nofeedbackimg-sty"
                                style={{ height: '500px', width: '750px' }}
                            />

                            <h2 className="tt-bold font-15 text-center">No policies were created so far. Click on "Create New Policy" to create a new policy</h2>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return getAllpolicy?.map((value, index) => {
                let perncentage = value.totalCount != 0 && value.ackCount != 0 ? (`${parseFloat(((value.totalCount) / (value.ackCount)) * 100).toFixed(0)}%`) : "NA"
                return (
                    <>
                        <tr>
                            <Tooltip title={value.policy_name.length > 20 ? value.policy_name : null}>
                                <td>
                                    <a href={`/policyform?viewId=${value.policy_id}`}>
                                        {value.policy_name.length > 20
                                            ? `${value.policy_name.substring(0, 20)}...`
                                            : value.policy_name}
                                    </a>
                                </td>
                            </Tooltip>
                            {/* <td><a href={`/policyform?viewId=${value.policy_id}`}>{value.policy_name}</a></td> */}
                            <td>{formatDate(value.start_date)}</td>
                            <td>{formatDate(value.expiry_date)}</td>
                            <Tooltip title={value.control_owners.length > 20 ? value.control_owners : null}>
                                <td>
                                    {value.control_owners.length > 20
                                        ? `${value.control_owners.substring(0, 20)}...`
                                        : value.control_owners}
                                </td>
                            </Tooltip>
                            <td>{value.category == "both" ?
                                "Groups,Individual" : value.category == "group" ?
                                    "Groups" : value.category == "individual" ?
                                        "Individual" : ""}</td>

                            {encryptStorage.getItem("grc") ?
                                <td>
                                    <span className="d-flex align-items-center gap-1">
                                        <img src="Images/Policy/ak-user.svg" alt="ak-user" />
                                        <span style={{ color: "blue" }}>{perncentage}</span>
                                    </span>
                                </td> : <></>}

                            <td>
                                <span className="appr-status d-flex gap-2">
                                    <span title={getEmpNames(1, value.approver_level)} className={`round-status ${getPolicyStatus(1, value.approver_level)}`}>
                                        1
                                    </span>
                                    <span title={getEmpNames(2, value.approver_level)} className={`round-status ${getPolicyStatus(2, value.approver_level)}`}>
                                        2
                                    </span>
                                    <span title={getEmpNames(3, value.approver_level)} className={`round-status ${getPolicyStatus(3, value.approver_level)}`}>
                                        3
                                    </span>
                                </span>
                            </td>
                            <td>
                                <button type="button" className="btn btn-policy-edit box-shadow-none"
                                    onClick={() => {
                                        if (encryptStorage.getItem('grc')) {
                                            value.ackCount == 0 ?
                                                navigateTo('/policyform', { state: value.policy_id }) :
                                                navigateTo(`/policyform?viewId=${value.policy_id}`)
                                        }
                                        else if (encryptStorage.getItem("secAudits") || encryptStorage.getItem('employeeId')) {
                                            (isApprovedOrRejected(
                                                encryptStorage.getItem("secAudits") ? "Sec Audits" : encryptStorage.getItem('employeeId'),
                                                value.approver_level
                                            )) ?
                                                navigateTo(`/policyform?viewId=${value.policy_id}`) :
                                                navigateTo('/policyform', { state: value.policy_id })
                                        }
                                    }
                                    }>
                                    {encryptStorage.getItem('grc') ? (
                                        value.ackCount == 0 ? (
                                            <img src="Images/Policy/policy-edit.svg" alt="policy-edit" />
                                        ) : (
                                            <img src="Images/Policy/eye-icon-policy.svg" alt="eye-icon-policy" />
                                        )
                                    ) : (
                                        (encryptStorage.getItem("secAudits") || encryptStorage.getItem('employeeId')) ? (
                                            isApprovedOrRejected(
                                                encryptStorage.getItem("secAudits") ? "Sec Audits" : encryptStorage.getItem('employeeId'),
                                                value.approver_level
                                            ) ? (
                                                <img src="Images/Policy/eye-icon-policy.svg" alt="eye-icon-policy" />
                                            ) : (
                                                <img src="Images/Policy/policy-edit.svg" alt="policy-edit" />
                                            )
                                        ) : null // Add a null return for the else condition
                                    )}
                                </button>
                            </td>
                        </tr >
                    </>
                );
            });
        }
    }

    // PC_PD_25 to  PC_PD_27 - to bind active policy
    function bindActivePolices() {
        //debugger;
        if (activePolices?.length == 0) {
            return (
                <tr>
                    <td colSpan={10}>
                        <div className="row justify-content-center">
                            <img
                                src="/Images/vadivelu.png"
                                alt="nodatafound"
                                className="nofeedbackimg-sty"
                                style={{ height: '500px', width: '750px' }}
                            />

                            <h2 className="tt-bold font-15 text-center">You have no existing policies in effect.</h2>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return activePolices?.map((value, index) => {
                return (
                    <>
                        <tr>
                            <td> {value.policy_name} </td>
                            {/* <td>
                                <span data-bs-toggle="tooltip" title={value.policy_description}>
                                    {value.policy_description}
                                </span>
                            </td> */}
                            <Tooltip title={value.policy_description.length > 20 ? value.policy_description : null}>
                                <td>
                                    <a>
                                        {value.policy_description.length > 20
                                            ? `${value.policy_description.substring(0, 20)}...`
                                            : value.policy_description}
                                    </a>
                                </td>
                            </Tooltip>
                            <td>{formatDate(value.created_at)}</td>
                            <td>
                                <button type="button" onClick={() => {
                                    setAddSign(value?.signed_policy_url ? getS3(value?.signed_policy_url) : getS3(value?.policy_url));
                                    setPolicyId(value?.policy_id);
                                    setPolicyName(value?.policy_name);
                                    value?.signed_policy_url ? setView(true) : setView(false);
                                    setPresignedURL(value?.policy_url);
                                    SetSign(value?.signature_required);
                                }} className="btn btn-policy-edit box-shadow-none">
                                    {value?.signed_policy_url ?
                                        <img src="Images/Policy/eye-icon-policy.svg" alt="eye-icon-policy" /> :
                                        <img src="Images/Policy/sign-pen.svg" alt="sign-pen" />}
                                </button>
                            </td>
                        </tr>
                    </>
                );
            });
        }
    }


    // PC_PD_26 to   PC_PD_28 to bind in active policy
    function bindInactivePolicies() {
        try {
            if (inactivePolicies?.length == 0) {
                return (
                    <tr>
                        <td colSpan={10}>
                            <div className="row justify-content-center">
                                <img
                                    src="/Images/vadivelu.png"
                                    alt="nodatafound"
                                    className="nofeedbackimg-sty"
                                    style={{ height: '500px', width: '750px' }}
                                />

                                <h2 className="tt-bold font-15 text-center">You have no existing policies in effect.</h2>
                            </div>
                        </td>
                    </tr>
                );
            } else {
                return inactivePolicies.map((value, index) => {
                    return (
                        <>
                            <tr>
                                <td>
                                    <a className="semibold-text">
                                        {value?.policy_name}
                                    </a>
                                </td>
                                <Tooltip title={value.policy_description.length > 20 ? value.policy_description : null}>
                                    <td>
                                        <a>
                                            {value.policy_description.length > 20
                                                ? `${value.policy_description.substring(0, 20)}...`
                                                : value.policy_description}
                                        </a>
                                    </td>
                                </Tooltip>
                                <td>{formatDate(value?.expiry_date)}</td>
                                <td>
                                    {/* <a href={signedURL(value?.policy_url)}  */}
                                    <a
                                    href="#"
                                    className="btn btn-policy-edit box-shadow-none"
                                    style={{ cursor: "pointer" }}
                                    onClick={async () => {
                                        const url = value?.policy_url ? await getS3(value.policy_url) : value.policy_url;
                                        window.open(url, "_blank");
                                    }}
                                >
                                    <img src="Images/Policy/eye-icon-policy.svg" alt="eye-icon-policy" />
                                    </a>
                                </td>
                            </tr>
                        </>
                    );
                });
            }
        } catch (error) {
            console.log(error.message);
            throw error;
        }
    }

    function handleClear() {
        setFilterData({ ...filterData, search: '' })
        setSearch('')
    }
    // render
    return (
        <>
            {!addSign ?
                <>
                    <div className="container-fluid mt-5">
                        <Loader isLoading={isLoading} />
                        <div className="row">
                            <div className="col-md-11" style={{ marginTop: '10px' }}>
                                <BreadCrumbs data={breadCrumbsData} />
                            </div>
                            <div className="col-md-12">
                                <div className=" px-4">
                                    <div className="d-flex align-items-center justify-content-between mt-3">
                                        <h2 className="mb-0 heading-color bold-text font-18">
                                            {encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") ? "Manage Policy" : "All Policy"}
                                        </h2>
                                        <div>
                                            <ul className="nav">
                                                {policyTab === 'all' ? (
                                                    <li>
                                                        <div className="input-group flex-nowrap search-group me-2">
                                                            <input
                                                                type="search"
                                                                className="form-control search-align"
                                                                placeholder="Search"
                                                                aria-label="Username"
                                                                aria-describedby="addon-wrapping"
                                                                value={filterData.search}
                                                                onChange={(e) => {
                                                                    handleSearch(e);
                                                                }}
                                                                onKeyUp={(e) => {
                                                                    handleSearchKeyDown(e);
                                                                }}
                                                            />
                                                            <button
                                                                className="input-group-text btn btn-search-custom align-items-center d-flex"
                                                                id="addon-wrapping"
                                                            >
                                                                <img
                                                                    src="Images/Policy/todo-find-icon.svg"
                                                                    alt="search-icon"
                                                                    className="todo-find-icon"
                                                                    onClick={() => {
                                                                        searchClick();
                                                                    }}
                                                                />
                                                            </button>
                                                        </div>
                                                    </li>
                                                ) : policyTab === 'active' || policyTab == 'allasactive' ? (
                                                    <li>
                                                        <div className="input-group flex-nowrap search-group me-2">
                                                            <input
                                                                type="search"
                                                                className="form-control search-align"
                                                                placeholder="Search"
                                                                aria-label="Username"
                                                                aria-describedby="addon-wrapping"
                                                                value={search}
                                                                onChange={(e) => {
                                                                    setSearch(e.target.value)
                                                                }}
                                                                onKeyUp={(e) => {
                                                                    handleSearchKeyDown(e);
                                                                }}

                                                            />
                                                            <button
                                                                className="input-group-text btn btn-search-custom align-items-center d-flex"
                                                                id="addon-wrapping"
                                                            >
                                                                <img
                                                                    src="Images/Policy/todo-find-icon.svg"
                                                                    alt="search-icon"
                                                                    className="todo-find-icon"
                                                                    onClick={() => {
                                                                        searchClick();
                                                                    }}
                                                                />
                                                            </button>
                                                        </div>
                                                    </li>
                                                ) : policyTab === 'inactive' ? (
                                                    <li>
                                                        <div className="input-group flex-nowrap search-group me-2">
                                                            <input
                                                                type="search"
                                                                className="form-control search-align"
                                                                placeholder="Search"
                                                                aria-label="Username"
                                                                aria-describedby="addon-wrapping"
                                                                value={search}
                                                                onChange={(e) => {
                                                                    setSearch(e.target.value);
                                                                }}
                                                                onKeyUp={(e) => {
                                                                    handleSearchKeyDown(e);
                                                                }}

                                                            />
                                                            <button
                                                                className="input-group-text btn btn-search-custom align-items-center d-flex"
                                                                id="addon-wrapping"
                                                            >
                                                                <img
                                                                    src="Images/Policy/todo-find-icon.svg"
                                                                    alt="search-icon"
                                                                    className="todo-find-icon"
                                                                    onClick={() => {
                                                                        searchClick();
                                                                    }}
                                                                />
                                                            </button>
                                                        </div>
                                                    </li>
                                                ) : null}
                                                <li>
                                                    {/*Filter Section Starts Here*/}
                                                    {encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ?
                                                        <div className="dropdown">
                                                            <button
                                                                className="advanced-filter-button me-2 medium-text"
                                                                type="button"
                                                                id="feedback-filter-dropdown"
                                                                data-bs-toggle="dropdown"
                                                                disabled={policyTab == 'active' || policyTab == 'inactive'}
                                                                onClick={() => {
                                                                    filterCheck();
                                                                    getFilterDropDowns();
                                                                }}
                                                            >
                                                                <img src="/Images/filter-icon.svg" className="me-2" />
                                                                Filter
                                                            </button>
                                                            {hideContainer && (
                                                                <div className="dropdown-menu px-3 advanced-filter-panel" style={{ display: 'block' }}>
                                                                    {/* <div className="col-md-12"> */}
                                                                    <div className="col-md-12 py-2 border-0 mb-1">
                                                                        <span className="font-16 semibold-text advanced-filter-title">
                                                                            Advanced Filter
                                                                        </span>

                                                                        <button
                                                                            type="button"
                                                                            className="btn-close float-end close-filter"
                                                                            data-bs-dismiss="advanced-filter"
                                                                            aria-label="Close"
                                                                            onClick={() => filterCheck()}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12 ">
                                                                        <div class="row mt-3">
                                                                            <div class="col-md-6 mb-3">
                                                                                {/* <div class="mb-3"> */}
                                                                                <label
                                                                                    class="form-label hive-form-label"
                                                                                    for="policyController"
                                                                                >
                                                                                    Policy Controller
                                                                                </label>
                                                                                <select
                                                                                    className="form-select hive-form-control"
                                                                                    id="controlOwnerId"
                                                                                    name="controlOwnerId"
                                                                                    onChange={(e) => {
                                                                                        setFilterData({
                                                                                            ...filterData,
                                                                                            ['controlOwnerId']: e.target.value,
                                                                                        });
                                                                                    }}
                                                                                    value={filterData.controlOwnerId}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {bindFilterDropDowns()}
                                                                                </select>
                                                                                {/* </div> */}
                                                                            </div>
                                                                            <div class="col-md-6 mb-3">
                                                                                <div class="mb-3">
                                                                                    <label
                                                                                        class="form-label hive-form-label"
                                                                                        for="category"
                                                                                    >
                                                                                        Category
                                                                                    </label>
                                                                                    <select
                                                                                        class="form-select hive-form-control"
                                                                                        id="category"
                                                                                        onChange={(e) => {
                                                                                            setFilterData({
                                                                                                ...filterData,
                                                                                                ['category']: e.target.value,
                                                                                            });
                                                                                        }}
                                                                                        value={filterData.category}
                                                                                    >
                                                                                        <option selected="">Select</option>
                                                                                        <option value="group">Group</option>
                                                                                        <option value="individual">Individual</option>
                                                                                        <option value="both">Both</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/* <div class="col-md-6 col-sm-12"> */}
                                                                        {/* <div class="mb-3">
                                                            <label class="form-label text-black font-14 bold-text"
                                                                for="status">Status</label>
                                                            <select
                                                                class="form-select cust-input-sty font-14 font-regular"
                                                                id="status">
                                                                <option selected="">Select</option>
                                                                <option value="1">High</option>
                                                                <option value="2">Average</option>
                                                                <option value="3">Low</option>
                                                            </select>
                                                        </div> */}
                                                                        {/* </div>  */}
                                                                        <div class="col-md-6 col-sm-12">
                                                                            <div class="mb-3">
                                                                                <label
                                                                                    class="form-label hive-form-label"
                                                                                    for="approver"
                                                                                >
                                                                                    Approver
                                                                                </label>
                                                                                <select
                                                                                    class="form-select hive-form-control"
                                                                                    id="approver"
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {bindFilterDropDowns()}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-12 pb-2 border-0">
                                                                            {/* <div className="mt-3"> */}
                                                                            <span className="font-14 semibold-text filter-title">Start Date</span>
                                                                            {/* </div> */}
                                                                        </div>
                                                                        <div className="row mb-3">
                                                                            <div className="col-md-6 mb-3">
                                                                                <label className="form-label hive-form-label" htmlFor="fromrange">
                                                                                    From
                                                                                </label>
                                                                                <input
                                                                                    type="date"
                                                                                    className="form-control hive-form-control"
                                                                                    id="fromrange"
                                                                                    name="startDate"
                                                                                    value={filterData.startFromDate}
                                                                                    max={filterObj.startFromDate}
                                                                                    onChange={(e) => {
                                                                                        setFilterData({
                                                                                            ...filterData,
                                                                                            ['startFromDate']: e.target.value,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-6 mb-3">
                                                                                <label className="form-label hive-form-label" htmlFor="torange">
                                                                                    To
                                                                                </label>
                                                                                <input
                                                                                    type="date"
                                                                                    className="form-control hive-form-control"
                                                                                    id="torange"
                                                                                    name="endDate"
                                                                                    value={filterData.startToDate}
                                                                                    max={filterObj.startToDate}
                                                                                    onChange={(e) => {
                                                                                        setFilterData({
                                                                                            ...filterData,
                                                                                            ['startToDate']: e.target.value,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-12 pb-2 border-0">
                                                                            {/* <div className="mt-3"> */}
                                                                            <span className="font-14 semibold-text filter-title">Expiry Date</span>
                                                                            {/* </div> */}
                                                                        </div>
                                                                        <div className="row mb-3">
                                                                            <div className="col-md-6 mb-3">
                                                                                <label className="form-label hive-form-label" htmlFor="fromrange">
                                                                                    From
                                                                                </label>
                                                                                <input
                                                                                    type="date"
                                                                                    className="form-control hive-form-control"
                                                                                    id="fromrange"
                                                                                    name="startDate"
                                                                                    value={filterData.expiryFromDate}
                                                                                    max={filterObj.expiryFromDate}
                                                                                    onChange={(e) => {
                                                                                        setFilterData({
                                                                                            ...filterData,
                                                                                            ['expiryFromDate']: e.target.value,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-6 mb-3">
                                                                                <label className="form-label hive-form-label" htmlFor="torange">
                                                                                    To
                                                                                </label>
                                                                                <input
                                                                                    type="date"
                                                                                    className="form-control hive-form-control"
                                                                                    id="torange"
                                                                                    name="endDate"
                                                                                    value={filterData.expiryToDate}
                                                                                    max={filterObj.expiryToDate}
                                                                                    onChange={(e) => {
                                                                                        setFilterData({
                                                                                            ...filterData,
                                                                                            ['expiryToDate']: e.target.value,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        {/* </div> */}
                                                                    </div>
                                                                    <div>
                                                                        <div className="text-end mt-4 mb-2">
                                                                            <button
                                                                                type="button"
                                                                                className="btn cancel-button btn-link text-black shadow-none font-14 bold-text px-3 me-3"
                                                                                onClick={(e) => {
                                                                                    filterclear();
                                                                                }}
                                                                            >
                                                                                Clear
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                                                onClick={() => {
                                                                                    setHideContainer(false);
                                                                                    allpolicy();
                                                                                }}
                                                                            >
                                                                                Apply
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {/* </div> */}
                                                                </div>
                                                            )}
                                                        </div> : <></>}
                                                    {/*Filter Section Ends Here*/}
                                                </li>
                                                <li>
                                                    {encryptStorage.getItem('grc') &&
                                                        <button
                                                            className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                            type="button"
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                            onClick={() => {
                                                                navigateTo('/policyform');
                                                            }}
                                                        >
                                                            Create New Policy
                                                        </button>}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* rejected toast starts */}
                                    {state == "rejected" ?
                                        <div className="rejected-toast position-fixed shadow-sm d-flex justify-content-between align-items-center">
                                            <span className="d-flex gap-3">
                                                <span><img src="Images/Policy/reject-icon-round.svg" /></span>
                                                <span>
                                                    <span className="d-block semibold-text font-16">Rejected</span>
                                                    <span className="d-block medium-text font-12">You have rejected the policy.</span>
                                                </span>
                                            </span>
                                            <span onClick={() => { setState("") }} className="cursor-pointer"><img src="Images/Policy/toast-cross.svg" alt="toast-cross" /></span>
                                        </div> : <></>}
                                    {/* rejected toast ends */}
                                    {/* Success toast starts */}
                                    {state == "approved" ?
                                        <div className="success-toast position-fixed shadow-sm d-flex justify-content-between align-items-center">
                                            <span className="d-flex gap-3">
                                                <span><img src="Images/Policy/sucess-toast-round.svg" /></span>
                                                <span>
                                                    <span className="d-block semibold-text font-16">Success</span>
                                                    <span className="d-block medium-text font-12">You have approved the policy
                                                        successfully.</span>
                                                </span>
                                            </span>
                                            <span onClick={() => { setState("") }} className="cursor-pointer"><img src="Images/Policy/toast-cross.svg" alt="toast-cross" /></span>
                                        </div> : <></>}
                                    {state == "edit" ?
                                        <div className="success-toast position-fixed shadow-sm d-flex justify-content-between align-items-center">
                                            <span className="d-flex gap-3">
                                                <span><img src="Images/Policy/sucess-toast-round.svg" /></span>
                                                <span>
                                                    <span className="d-block semibold-text font-16">Success</span>
                                                    <span className="d-block medium-text font-12">You have updated the policy
                                                        successfully.</span>
                                                </span>
                                            </span>
                                            <span onClick={() => { setState("") }} className="cursor-pointer"><img src="Images/Policy/toast-cross.svg" alt="toast-cross" /></span>
                                        </div> : <></>}
                                    {state == "success" ?
                                        <div className="success-toast position-fixed shadow-sm d-flex justify-content-between align-items-center">
                                            <span className="d-flex gap-3">
                                                <span><img src="Images/Policy/sucess-toast-round.svg" /></span>
                                                <span>
                                                    <span className="d-block semibold-text font-16">Success</span>
                                                    <span className="d-block medium-text font-12">You have Created a policy
                                                        successfully.</span>
                                                </span>
                                            </span>
                                            <span onClick={() => { setState("") }} className="cursor-pointer"><img src="Images/Policy/toast-cross.svg" alt="toast-cross" /></span>
                                        </div> : <></>}
                                    {/* {/* Success toast ends} */}

                                    <ul className="nav nav-tabs border-0 mt-3 mb-4">
                                        {encryptStorage.getItem('grc') || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ?
                                            <>
                                                <li className="nav-item me-4">
                                                    <button
                                                        className="nav-link active border-0 policy-tab font-14 semibold-text"
                                                        data-bs-toggle="tab"
                                                        data-bs-target="#allPolicy"
                                                        type="button"
                                                        aria-selected={encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ? "true" : "false"}
                                                        onClick={() => { setPolicyTab('all'); handleClear() }}
                                                    // onClick={navigateTo('')}
                                                    >
                                                        All Policy
                                                    </button>
                                                    {/* ):(<></>)} */}
                                                </li>


                                                <li className="nav-item me-4">
                                                    {/* {encryptStorage.getItem('secAudits') || encryptStorage.getItem('grc')||
                                encryptStorage.getItem('employeeId')|| (encryptStorage.getItem('groupid')==1)?
                                    ( */}
                                                    <button
                                                        className={encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ?
                                                            "nav-link border-0 policy-tab font-14 semibold-text" :
                                                            "nav-link border-0 policy-tab font-14 semibold-text active"}
                                                        data-bs-toggle="tab"
                                                        data-bs-target="#activePolicy"
                                                        type="button"
                                                        aria-selected={encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ? "false" : "true"}
                                                        onClick={() => {

                                                            {
                                                                encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ?
                                                                    setPolicyTab('active') : setPolicyTab('allasactive')
                                                            }
                                                            handleClear()
                                                        }}
                                                    // onClick={navigateTo('')}
                                                    >
                                                        {
                                                            encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ?
                                                                "Active Policy" : "All Policy"
                                                        }
                                                    </button>
                                                    {/* ):(<></>)} */}
                                                </li>
                                            </> : (<></>)}

                                        {encryptStorage.getItem('grc') ?
                                            <li className="nav-item me-4">
                                                <button
                                                    className="nav-link border-0 policy-tab font-14 semibold-text"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#inActivePolicy"
                                                    type="button"
                                                    aria-selected="false"
                                                    onClick={() => { setPolicyTab('inactive'); handleClear() }}
                                                //onClick={navigateTo('')}
                                                >
                                                    Inactive Policy
                                                </button>
                                            </li>
                                            : <></>}
                                    </ul>
                                    <div className="tab-content">
                                        {/* {
                             encryptStorage.getItem('secAudits') || (encryptStorage.getItem('groupid')==1) ?
                              //  || encryptStorage.getItem('grc') 
                              
                                    ( */}
                                        <div
                                            className={
                                                encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ?
                                                    "tab-pane fade show active" : "tab-pane fade"
                                            }
                                            id="allPolicy" role="tabpanel">
                                            <div className="table-responsive table-overflow-visible">
                                                <table className="table bg-white hive-grid table-borderless">
                                                    <thead className="hive-table-head">
                                                        <tr>
                                                            <th>
                                                                Policy Name
                                                                <span className="ms-2">
                                                                    <span className="ps-2">
                                                                        <img
                                                                            src="Images/Policy/sort-down.svg"
                                                                            className="hive-table-sort"
                                                                            id="policy_name@DESC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'policy_name@DESC' ? true : false}
                                                                        />
                                                                        <img
                                                                            src="Images/Policy/sort-up.svg"
                                                                            className="hive-table-sort"
                                                                            id="policy_name@ASC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'policy_name@DESC' ? false : true}
                                                                        />
                                                                    </span>
                                                                    {/* <img
                                                                    src="Images/Policy/sort-down.svg"
                                                                    alt="sort-down"
                                                                    className="cursor-pointer"
                                                                    onClick={(e) =>{
                                                                        setFilterData({...filterData, ["sort"]:'policy_name'})
                                                                    }}
                                                                />
                                                                : <img
                                                                src="Images/Policy/sort-down.svg"
                                                                alt="sort-down"
                                                                className="cursor-pointer"
                                                                
                                                                onClick={(e) =>{
                                                                    setFilterData({...filterData, ["sort"]:'policy_name'})
                                                                }}
                                                            /> */}
                                                                </span>
                                                            </th>
                                                            <th>
                                                                Start Date
                                                                <span className="ms-2">
                                                                    <span className="ps-2">
                                                                        <img
                                                                            src="Images/Policy/sort-down.svg"
                                                                            className="hive-table-sort"
                                                                            id="start_date@DESC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'start_date@DESC' ? true : false}
                                                                        />
                                                                        <img
                                                                            src="Images/Policy/sort-up.svg"
                                                                            className="hive-table-sort"
                                                                            id="start_date@ASC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'start_date@DESC' ? false : true}
                                                                        />
                                                                    </span>
                                                                </span>
                                                            </th>
                                                            <th>
                                                                Expiry Date
                                                                <span className="ms-2">
                                                                    <span className="ps-2">
                                                                        <img
                                                                            src="Images/Policy/sort-down.svg"
                                                                            className="hive-table-sort"
                                                                            id="expiry_date@DESC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'expiry_date@DESC' ? true : false}
                                                                        />
                                                                        <img
                                                                            src="Images/Policy/sort-up.svg"
                                                                            className="hive-table-sort"
                                                                            id="expiry_date@ASC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'expiry_date@DESC' ? false : true}
                                                                        />
                                                                    </span>
                                                                </span>
                                                            </th>
                                                            <th>Policy Controller</th>
                                                            <th>Category
                                                                <span className="ms-2">
                                                                    <span className="ps-2">
                                                                        <img
                                                                            src="Images/Policy/sort-down.svg"
                                                                            className="hive-table-sort"
                                                                            id="category@DESC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'category@DESC' ? true : false}
                                                                        />
                                                                        <img
                                                                            src="Images/Policy/sort-up.svg"
                                                                            className="hive-table-sort"
                                                                            id="category@ASC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'category@DESC' ? false : true}
                                                                        />
                                                                    </span>
                                                                </span>
                                                            </th>
                                                            {encryptStorage.getItem("grc") ?
                                                                <th>Ack Users
                                                                    <span className="ms-2">
                                                                        <span className="ps-2">
                                                                            <img
                                                                                src="Images/Policy/sort-down.svg"
                                                                                className="hive-table-sort"
                                                                                id="acknowledgment_count@DESC"
                                                                                onClick={(e) => sortClicked(e)}
                                                                                hidden={sorthide == 'acknowledgment_count@DESC' ? true : false}
                                                                            />
                                                                            <img
                                                                                src="Images/Policy/sort-up.svg"
                                                                                className="hive-table-sort"
                                                                                id="acknowledgment_count@ASC"
                                                                                onClick={(e) => sortClicked(e)}
                                                                                hidden={sorthide == 'acknowledgment_count@DESC' ? false : true}
                                                                            />
                                                                        </span>
                                                                    </span>
                                                                </th> : <></>}
                                                            <th>Approver Status</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="regular-text font-12">{bindAllPolices()}</tbody>
                                                </table>
                                            </div>
                                            {(pagination > 10) ?
                                                <div className="text-center mb-3">
                                                    <button className="btn show-more-btn"
                                                        // hidden={encryptStorage.getItem('grc')?getAllpolicy?.length == pagination-1:getAllpolicy?.length == pagination}
                                                        hidden={getAllpolicy?.length == pagination}
                                                        onClick={(e) => {
                                                            setFilterData({
                                                                ...filterData,
                                                                "limit": filterData.limit + 10
                                                            })
                                                        }}>
                                                        Show More
                                                    </button>
                                                </div> : (<></>)}
                                            <p className="font-12 regular-text mt-2">
                                                Showing <span className="bold-text">{getAllpolicy?.length}</span> of {pagination}
                                            </p>
                                        </div>
                                        {/* ):(<></>)} */}

                                        {/* {encryptStorage.getItem('secAudits') || (encryptStorage.getItem('groupid')==1)
                              // || encryptStorage.getItem('grc') 
                              ||encryptStorage.getItem('employeeId')
                              ?
                              
                                  ( */}
                                        <div className={
                                            encryptStorage.getItem("grc") || encryptStorage.getItem("secAudits") || encryptStorage.getItem("groupid") == 1 ?
                                                "tab-pane fade" : "tab-pane fade show active"
                                        } id="activePolicy" role="tabpanel">
                                            <div className="table-responsive table-overflow-visible">
                                                <table className="table bg-white hive-grid table-borderless">
                                                    <thead className="hive-table-head">
                                                        <tr>
                                                            <th>
                                                                Policy Name
                                                                <span className="ms-2">
                                                                    <span className="ps-2">
                                                                        <img
                                                                            src="Images/Policy/sort-down.svg"
                                                                            className="hive-table-sort"
                                                                            id="p.policy_name@DESC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'p.policy_name@DESC' ? true : false}
                                                                        />
                                                                        <img
                                                                            src="Images/Policy/sort-up.svg"
                                                                            className="hive-table-sort"
                                                                            id="p.policy_name@ASC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'p.policy_name@DESC' ? false : true}
                                                                        />
                                                                    </span>
                                                                </span>

                                                                {/* <span className="ps-2">
                                                                    <img
                                                                        src="Images/Policy/sort-down.svg"
                                                                        className="hive-table-sort"
                                                                        id="policy_name@ASC"
                                                                        hidden={sortOrder == 'asc'}
                                                                        // hidden={sortIcon=='policy_name@ASC'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSort('policy_name')}
                                                                    />
                                                                    <img
                                                                        src="Images/Policy/sort-up.svg"
                                                                        className="hive-table-sort"
                                                                        id="policy_name@DESC"
                                                                        hidden={sortOrder == 'desc'}
                                                                        // hidden={sortIcon=='policy_name@DESC'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSort('policy_name')}
                                                                    />
                                                                </span> */}
                                                            </th>
                                                            <th>
                                                                Policy Description
                                                                <span className="ms-2">
                                                                    <span className="ps-2">
                                                                        <img
                                                                            src="Images/Policy/sort-down.svg"
                                                                            className="hive-table-sort"
                                                                            id="p.policy_description@DESC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'p.policy_description@DESC' ? true : false}
                                                                        />
                                                                        <img
                                                                            src="Images/Policy/sort-up.svg"
                                                                            className="hive-table-sort"
                                                                            id="p.policy_description@ASC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'p.policy_description@DESC' ? false : true}
                                                                        />
                                                                    </span>
                                                                </span>

                                                                {/* <span className="ms-2">
                                                                    <img
                                                                        src="Images/Policy/sort-down.svg"
                                                                        className="hive-table-sort"
                                                                        id="policy_description@ASC"
                                                                        hidden={sortOrder == 'asc'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSort('policy_description')}
                                                                    />
                                                                    <img
                                                                        src="Images/Policy/sort-up.svg"
                                                                        className="hive-table-sort"
                                                                        id="policy_name@DESC"
                                                                        hidden={sortOrder == 'desc'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSort('policy_description')}
                                                                    />
                                                                </span> */}
                                                            </th>
                                                            <th>
                                                                Published Date
                                                                <span className="ms-2">
                                                                    <span className="ps-2">
                                                                        <img
                                                                            src="Images/Policy/sort-down.svg"
                                                                            className="hive-table-sort"
                                                                            id="p.created_at@DESC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'p.created_at@DESC' ? true : false}
                                                                        />
                                                                        <img
                                                                            src="Images/Policy/sort-up.svg"
                                                                            className="hive-table-sort"
                                                                            id="p.created_at@ASC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'p.created_at@DESC' ? false : true}
                                                                        />
                                                                    </span>
                                                                </span>

                                                                {/* <span classNtoame="ms-2">
                                                                    <img
                                                                        src="Images/Policy/sort-down.svg"
                                                                        className="hive-table-sort"
                                                                        id="created_at@ASC"
                                                                        hidden={sortOrder == 'asc'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSort('created_at')}
                                                                    />
                                                                    <img
                                                                        src="Images/Policy/sort-up.svg"
                                                                        className="hive-table-sort"
                                                                        id="created_at@DESC"
                                                                        hidden={sortOrder == 'desc'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSort('created_at')}
                                                                    />
                                                                </span> */}
                                                            </th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="regular-text font-12">{bindActivePolices()}</tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* ):(<></>)} */}

                                        {/* if(encryptStorage.getItem ('grc')) */}
                                        <div className="tab-pane fade" id="inActivePolicy" role="tabpanel">
                                            <div className="table-responsive table-overflow-visible">
                                                <table className="table bg-white hive-grid table-borderless">
                                                    <thead className="hive-table-head">
                                                        <tr>
                                                            <th>
                                                                Policy Name{' '}
                                                                <span className="ms-2">
                                                                    <img
                                                                        src="Images/Policy/sort-down.svg"
                                                                        className="hive-table-sort"
                                                                        id="policy_name@ASC"
                                                                        hidden={sortOrderr == 'asc'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSortt('policy_name')}
                                                                    />
                                                                    <img
                                                                        src="Images/Policy/sort-up.svg"
                                                                        className="hive-table-sort"
                                                                        id="policy_name@DESC"
                                                                        hidden={sortOrderr == 'desc'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSortt('policy_name')}
                                                                    />
                                                                </span>
                                                            </th>
                                                            <th>
                                                                Policy Description
                                                                <span className="ms-2">
                                                                    <img
                                                                        src="Images/Policy/sort-down.svg"
                                                                        className="hive-table-sort"
                                                                        id="policy_description@ASC"
                                                                        hidden={sortOrderr == 'asc'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSortt('policy_description')}
                                                                    />
                                                                    <img
                                                                        src="Images/Policy/sort-up.svg"
                                                                        className="hive-table-sort"
                                                                        id="policy_name@DESC"
                                                                        hidden={sortOrderr == 'desc'}
                                                                        // value={getActivePolices.policy_name}
                                                                        onClick={() => handleSortt('policy_description')}
                                                                    />
                                                                </span>
                                                            </th>
                                                            <th>
                                                                Expired Date
                                                                <span className="ms-2">
                                                                    <span className="ps-2">
                                                                        <img
                                                                            src="Images/Policy/sort-down.svg"
                                                                            className="hive-table-sort"
                                                                            id="expiry_date@DESC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'expiry_date@DESC' ? true : false}
                                                                        />
                                                                        <img
                                                                            src="Images/Policy/sort-up.svg"
                                                                            className="hive-table-sort"
                                                                            id="expiry_date@ASC"
                                                                            onClick={(e) => sortClicked(e)}
                                                                            hidden={sorthide == 'expiry_date@DESC' ? false : true}
                                                                        />
                                                                    </span>
                                                                </span>

                                                            </th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="regular-text font-12">{bindInactivePolicies()}</tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span className="cursor-pointer me-2">
                            <img src="Images/Policy/alert-left-arr.svg" alt="alert-left-arr" />
                        </span>
                        <span className="cursor-pointer ms-2">
                            <img src="Images/Policy/alert-right-arr.svg" alt="alert-left-arr" />
                        </span>
                    </div>
                </> : <></>
            }

            {addSign ?
                <>
                    {<Sign doc={addSign}
                        view={view}
                        policyId={policyId}
                        policyname={policyName}
                        sign={sign}
                        preSignedURL={preSignedURL}
                        End={(newPDf) => {
                            //debugger;
                            setAddSign("")
                            if (newPDf) {
                                getActivePolicy()
                            }
                        }} />}
                </> : <></>
            }

        </>
    );
}
